/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  APPLICATION_VIEW_CORPORATE,
  APPLICATION_VIEW_MASTER,
  APPLICATION_VIEW_OFFICE,
} from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { ChecklistsListComponent } from './components/checklists-list/checklists-list.component';
import { ChecklistsBusinessService } from './resources';
import { ChecklistsDetailComponent } from './components/checklists-detail';

const routes = [
  createRoute({
                component: ChecklistsListComponent,
                path: '',
                init: ChecklistsBusinessService,
                auth: {
                  applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
                  permission: [
                    'Setup.Checklists.LIST',
                  ],
                },
              }),
  createRoute({
                component: ChecklistsDetailComponent,
                path: 'new',
                init: {
                  service: ChecklistsBusinessService,
                  selector: 'initDetailsView',
                },
                leave: true,
                auth: {
                  applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
                  permission: [
                    'Setup.Checklists.CREATE',
                  ],
                },
              }),
  createRoute({
                component: ChecklistsDetailComponent,
                path: ':id',
                pathMatch: 'full',
                init: {
                  service: ChecklistsBusinessService,
                  selector: 'initDetailsView',
                },
                leave: true,
                auth: {
                  applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
                  permission: [
                    'Setup.Checklists.EDIT',
                    'Setup.Checklists.VIEW',
                  ],
                },
              }),
];

@NgModule({
            imports: [RouterModule.forChild(routes)],
            exports: [RouterModule],
          })
export class BuilderSetupChecklistsRoutingModule {
}
